<template>
  <div class="exam">
    <div class="nuv">
      <a :href="'/tjkStudy/operatorExamine?groupId='+groupId+'&groupName='+groupName" target="_blank" class="active">群培训管理</a>&gt;
      <span>语音考核</span>
    </div>
    <div class="end">
      <span>当前拨打电话：{{ callPhone }}</span>
      <el-button type="danger" @click="endExam()">结束考核</el-button>
    </div>
    <template v-if="!currentExamRecord">
      <p class="nopeople">名单中全部人员考核结束</p>
    </template>
    <template v-else>
      <div class="current">
        <div class="content">
          <table>
            <tr>
              <th>考核人员</th>
              <th>电话</th>
              <th>淘金号</th>
              <th>是否通过</th>
              <th>综合得分</th>
              <th>备注</th>
              <th></th>
            </tr>
            <tr>
              <td>{{ realName }}</td>
              <td>{{ loginName }}</td>
              <td>{{ tjkNumber }}</td>
              <td>
                <el-select v-model="passState" placeholder="请选择">
                  <el-option key="Passed" label="通过" value="Passed"></el-option>
                  <el-option key="Failed" label="未通过" value="Failed"></el-option>
                  <el-option key="NotExamine" label="未考" value="NotExamine"></el-option>
                  <el-option key="Loss" label="流失" value="Loss"></el-option>
                  <el-option key="Cancel" label="取消资格" value="Cancel"></el-option>
                </el-select>
              </td>
              <td>
                <el-input placeholder="只能填写数字" v-model.number="score" clearable></el-input>
              </td>
              <td>
                <el-input type="textarea" autosize placeholder="不能超过200字" v-model="remark" clearable></el-input>
              </td>
              <td>
                <el-button type="primary" @click="saveScore">保存打分</el-button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </template>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <p class="tj-shift-notice" v-if="!list.length">暂无记录！</p>
      <template v-else>
        <h3>考核名单</h3>
        <el-table :data="list" border>
          <el-table-column prop="sequence" label="顺序" width="60" align="center"></el-table-column>
          <el-table-column prop="realName" label="考核人员" align="center"></el-table-column>
          <el-table-column prop="loginName" label="电话" align="center"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" align="center"></el-table-column>
          <el-table-column label="是否通过" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.passState == 'Passed'">通过</span>
              <span v-if="scope.row.passState == 'Failed'">未通过</span>
              <span v-if="scope.row.passState == 'NotExamine'">未考</span>
              <span v-if="scope.row.passState == 'Loss'">流失</span>
              <span v-if="scope.row.passState == 'Cancel'">取消资格</span>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="综合得分" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center"></el-table-column>
          <el-table-column prop="isFinish" label="是否完成考核" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isFinish == 'No'">否</span>
              <span v-if="scope.row.isFinish == 'Yes'">是</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      success: true,
      message: '',
      groupId: this.$route.query.groupId,
      groupName: this.$route.query.groupName,
      operatorExamId: this.$route.query.id ? this.$route.query.id : '', //从列表页tab点击传入
      list: this.$route.query.list ? this.$route.query.list : [], //考核记录列表
      currentExamRecord: this.$route.query.current ? this.$route.query.current : '', //当前考核人
      callPhone: this.$route.query.phone ? this.$route.query.phone : '', //当前考核人
      recordId: '',
      examRecordId: '',
      passState: '',
      score: '',
      remark: '',
      realName: '',
      loginName: '',
      tjkNumber: ''
    }
  },
  mounted: function() {
    this.initUser()
  },
  methods: {
    //查询当前考核人员信息
    initUser() {
      var data = {
        'operatorExamId': this.operatorExamId
      }
      this.$http.post(API_ROOT.college + '/operatorExam/enterOperatorExam', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.list = result.data.operatorExamRecords
          if(result.data.currentExamRecord) {
            this.currentExamRecord = result.data.currentExamRecord
            this.passState = result.data.currentExamRecord.passState
            this.score = result.data.currentExamRecord.score
            this.remark = result.data.currentExamRecord.remark
            this.realName = result.data.currentExamRecord.realName
            this.loginName = result.data.currentExamRecord.loginName
            this.tjkNumber = result.data.currentExamRecord.tjkNumber
            this.recordId = result.data.currentExamRecord.recordId
            this.examRecordId = result.data.currentExamRecord.examRecordId
          }else {
            this.currentExamRecord = null
            this.passState = ''
            this.score = ''
            this.remark = ''
            this.realName = ''
            this.loginName = ''
            this.tjkNumber = ''
            this.recordId = ''
            this.examRecordId = ''
          }
          this.callPhone = result.data.callPhone
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //语音考核打分并标记是否通过
    saveScore() {
      var reg = /^[1-9]\d*|0$/
      if((!!this.score && !reg.test(this.score))) {
        this.$alert('分数只能是非负整数')
        return false
      }
      if(!!this.remark && this.remark.length > 200) {
        this.$alert('备注不能超过200字')
        return false
      }
      var data = {
        'groupId': this.groupId,
        'operatorExamId': this.operatorExamId,
        'examRecordId': this.examRecordId,
        'recordId': this.recordId,
        'passState': this.passState,
        'score': !!this.score ? this.score : 0,
        'remark': !!this.remark ? this.remark : ''
      }
      this.$http.post(API_ROOT.college + '/operatorExam/saveOperatorExamRecord', data).then(response => {
        var result = response.data
        if(result.success) {
          this.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          })
          this.initUser()
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //考核结束
    endExam() {
      var data = {
        'operatorExamId': this.operatorExamId
      }
      this.$http.post(API_ROOT.college + '/operatorExam/endOperatorExam', data).then(response => {
        var result = response.data
        if(result.success) {
          window.location.href = '/tjkStudy/operatorExamine?groupId='+this.groupId+'&groupName='+this.groupName
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    }
  }
}
</script>
<style type="less" scoped>
  h3 {
    margin-top: 20px;
  }
  .nuv {
    font-size: 16px;
  }
  .current {
    border: 1px solid #dfdfdf;
    background-color: #ffffff;
  }
  .current .tab {
    border-bottom: 1px solid #dfdfdf;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .current .content {
    padding: 10px;
  }
  table > tr > th, table > tr > td {
    padding: 5px;
  }
  .content .button {
    margin: 0px 5px 10px 5px;
  }
  .end {
    margin-bottom: 20px;
    margin-top: 10px;
  }
  .end > span {
    padding: 0 20px;
    font-size: 18px;
  }
  .nopeople {
    padding: 10px 0 20px;
  }
</style>


// WEBPACK FOOTER //
// ./src/page/provider/enterExam.vue